/**
 * Icons available in manager Site Builder (IconSelect / ServiceIcon).
 * Keep in sync with manager/frontend/src/components/Common/ServiceIcon.js
 */

import {
  FaBed,
  FaPlane,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaBus,
  FaBusAlt,
  FaCar,
  FaTaxi,
  FaTrain,
  FaShip,
  FaBicycle,
  FaWalking,
  FaHotel,
  FaSwimmingPool,
  FaSpa,
  FaUtensils,
  FaCoffee,
  FaWineGlass,
  FaCocktail,
  FaUmbrellaBeach,
  FaMountain,
  FaMonument,
  FaLandmark,
  FaCamera,
  FaImage,
  FaVideo,
  FaMusic,
  FaSun,
  FaUsers,
  FaUserFriends,
  FaBaby,
  FaUsersCog,
  FaClipboardCheck,
  FaHeadset,
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaLanguage,
  FaFlag,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaClock,
  FaMapMarkerAlt,
  FaMap,
  FaRoute,
  FaCompass,
  FaNetworkWired,
  FaProjectDiagram,
  FaSitemap,
  FaLaptop,
  FaDesktop,
  FaLaptopCode,
  FaStar,
  FaHeart,
  FaAward,
  FaTrophy,
  FaGift,
  FaCreditCard,
  FaShoppingBag,
  FaShoppingCart,
  FaHandshake,
  FaCheckCircle,
} from 'react-icons/fa';

import {
  FaSuitcaseRolling,
  FaCarRear,
  FaCarSide,
  FaVanShuttle,
  FaTruck,
  FaUsersGear,
  FaPeopleLine,
  FaUserGroup,
  FaUserTie,
  FaUserCheck,
  FaHandshakeSimple,
  FaRegLightbulb,
  FaMapLocationDot,
  FaLocationPin,
  FaLocationDot,
  FaArrowTrendUp,
  FaScaleBalanced,
  FaPersonSwimming,
  FaPersonRunning,
  FaPersonBiking,
  FaPersonHiking,
  FaMountainSun,
  FaWaterLadder,
  FaWater,
} from 'react-icons/fa6';

import {
  BsFillStopwatchFill,
  BsFillLightningFill,
  BsClock,
  BsClockFill,
  BsAlarm,
  BsAlarmFill,
  BsShieldFillCheck,
  BsShieldCheck,
  BsShieldLock,
  BsShieldLockFill,
  BsShield,
  BsShieldFill,
  BsCheckCircle,
  BsCheckCircleFill,
  BsXCircle,
  BsXCircleFill,
  BsInfoCircle,
  BsInfoCircleFill,
  BsExclamationCircle,
  BsExclamationCircleFill,
  BsQuestionCircle,
  BsQuestionCircleFill,
  BsStar,
  BsStarFill,
  BsHeart,
  BsHeartFill,
  BsBookmark,
  BsBookmarkFill,
  BsGeoAlt,
  BsGeoAltFill,
  BsMap,
  BsMapFill,
  BsCompass,
  BsCompassFill,
  BsTelephone,
  BsTelephoneFill,
  BsEnvelope,
  BsEnvelopeFill,
  BsChat,
  BsChatFill,
  BsBriefcase,
  BsBriefcaseFill,
  BsBuilding,
  BsBuildingFill,
  BsShop,
  BsShopWindow,
  BsLaptop,
  BsLaptopFill,
  BsDisplay,
  BsDisplayFill,
  BsPCircle,
  BsPCircleFill,
  BsPeople,
  BsPeopleFill,
  BsPerson,
  BsPersonFill,
  BsPersonCheck,
  BsPersonCheckFill,
} from 'react-icons/bs';

export const siteBuilderIconMap = {
  FaBed,
  FaPlane,
  FaPlaneArrival,
  FaPlaneDeparture,
  FaBus,
  FaBusAlt,
  FaCar,
  FaTaxi,
  FaTrain,
  FaShip,
  FaBicycle,
  FaWalking,
  FaHotel,
  FaSwimmingPool,
  FaSpa,
  FaUtensils,
  FaCoffee,
  FaWineGlass,
  FaCocktail,
  FaUmbrellaBeach,
  FaMountain,
  FaMonument,
  FaLandmark,
  FaCamera,
  FaImage,
  FaVideo,
  FaMusic,
  FaSun,
  FaUsers,
  FaUserFriends,
  FaBaby,
  FaUsersCog,
  FaClipboardCheck,
  FaHeadset,
  FaPhone,
  FaEnvelope,
  FaGlobe,
  FaLanguage,
  FaFlag,
  FaCalendar,
  FaCalendarAlt,
  FaCalendarCheck,
  FaClock,
  FaMapMarkerAlt,
  FaMap,
  FaRoute,
  FaCompass,
  FaNetworkWired,
  FaProjectDiagram,
  FaSitemap,
  FaLaptop,
  FaDesktop,
  FaLaptopCode,
  FaStar,
  FaHeart,
  FaAward,
  FaTrophy,
  FaGift,
  FaCreditCard,
  FaShoppingBag,
  FaShoppingCart,
  FaHandshake,
  FaCheckCircle,
  FaSuitcaseRolling,
  FaCarRear,
  FaCarSide,
  FaVanShuttle,
  FaTruck,
  FaUsersGear,
  FaPeopleLine,
  FaUserGroup,
  FaUserTie,
  FaUserCheck,
  FaHandshakeSimple,
  FaRegLightbulb,
  FaMapLocationDot,
  FaLocationPin,
  FaLocationDot,
  FaArrowTrendUp,
  FaScaleBalanced,
  FaPersonSwimming,
  FaPersonRunning,
  FaPersonBiking,
  FaPersonHiking,
  FaMountainSun,
  FaWaterLadder,
  FaWater,
  BsFillStopwatchFill,
  BsFillLightningFill,
  BsClock,
  BsClockFill,
  BsAlarm,
  BsAlarmFill,
  BsShieldFillCheck,
  BsShieldCheck,
  BsShieldLock,
  BsShieldLockFill,
  BsShield,
  BsShieldFill,
  BsCheckCircle,
  BsCheckCircleFill,
  BsXCircle,
  BsXCircleFill,
  BsInfoCircle,
  BsInfoCircleFill,
  BsExclamationCircle,
  BsExclamationCircleFill,
  BsQuestionCircle,
  BsQuestionCircleFill,
  BsStar,
  BsStarFill,
  BsHeart,
  BsHeartFill,
  BsBookmark,
  BsBookmarkFill,
  BsGeoAlt,
  BsGeoAltFill,
  BsMap,
  BsMapFill,
  BsCompass,
  BsCompassFill,
  BsTelephone,
  BsTelephoneFill,
  BsEnvelope,
  BsEnvelopeFill,
  BsChat,
  BsChatFill,
  BsBriefcase,
  BsBriefcaseFill,
  BsBuilding,
  BsBuildingFill,
  BsShop,
  BsShopWindow,
  BsLaptop,
  BsLaptopFill,
  BsDisplay,
  BsDisplayFill,
  BsPCircle,
  BsPCircleFill,
  BsPeople,
  BsPeopleFill,
  BsPerson,
  BsPersonFill,
  BsPersonCheck,
  BsPersonCheckFill,
};

/** Same keys as siteBuilderIconMap (About page components import this name). */
export const iconMap = siteBuilderIconMap;

/**
 * Resolve DB / form icon name to a React icon component.
 * Case-insensitive so values like "famountainsun" still match "FaMountainSun".
 */
export function resolveSiteBuilderIconComponent(raw) {
  if (raw == null) return null;
  const k = String(raw).trim();
  if (!k) return null;
  if (siteBuilderIconMap[k]) return siteBuilderIconMap[k];
  const found = Object.keys(siteBuilderIconMap).find((name) => name.toLowerCase() === k.toLowerCase());
  return found ? siteBuilderIconMap[found] : null;
}
